import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { RouterProvider } from '@tanstack/react-router';

import { CustomTheme } from '@/_containers/custom-theme';
import { stagWorksTheme } from '@/_shared/styles/theme/theme';
import { persistOptions, queryClient } from '@/_shared/utils/query-client';

import { tsRouter } from './router';

function App() {
  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
      <CustomTheme usePreferences={false} theme={stagWorksTheme}>
        <RouterProvider router={tsRouter} defaultPreload="intent" />
      </CustomTheme>
      <ReactQueryDevtools initialIsOpen={false} />
    </PersistQueryClientProvider>
  );
}

export default App;
